/* eslint-disable no-alert */
import React from 'react'
import size from 'lodash/size'
import map from 'lodash/map'
import startCase from 'lodash/startCase'
import capitalize from 'lodash/capitalize'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Card, Image, Button, Icon, Header, Segment, Dropdown } from 'semantic-ui-react'

import firebase from '../../../config/firebase'

const STATUS = [
  { key: 'all', value: 'all', text: 'All' },
  { key: 'active', value: 'active', text: 'Active' },
  { key: 'expired', value: 'expired', text: 'Expired' },
]

const PLACEMENT = [
  { key: 'all', value: 'all', text: 'All' },
  { key: 'entry_point_happening', value: 'entry_point_happening', text: 'Entry Point Happening' },
  { key: 'entry_point_new', value: 'entry_point_new', text: 'Entry Point New' },
  { key: 'food', value: 'food', text: 'Food' },
  { key: 'mart', value: 'mart', text: 'Mart' },
]

const DropdownField = ({ label, value, onChange, options }) => {
  return (
    <div style={{ fontSize: 15 }}>
      {label}
      <Dropdown
        options={options}
        selection
        value={value}
        style={{ marginLeft: 10, marginRight: 10 }}
        onChange={(e, data) => onChange(data.value)}
      />
    </div>
  )
}

export default class SponsorSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      placement: 'all',
      status: 'all',
      displaySponsors: props.sponsors,
    }
  }

  componentDidUpdate(prevProps) {
    const { sponsors } = this.props

    if (prevProps.sponsors !== sponsors) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ displaySponsors: sponsors })
    }
  }

  onEditSponsorClick = sponsor => {
    const { history } = this.props

    history.push({
      pathname: `/advertisement/sponsor/${sponsor.sponsorKey}/edit`,
      state: { sponsorData: sponsor },
    })
  }

  onDeleteSponsorClick = sponsor => {
    const conf = window.confirm(`Are you sure to delete ${sponsor.restaurant} sponsor?`)

    if (conf) {
      this.removeSponsor(sponsor)
    }
  }

  onFilter = () => {
    const { placement, status } = this.state
    const { sponsors } = this.props

    let filteredSponsors = sponsors

    if (placement !== 'all') {
      filteredSponsors = filteredSponsors.filter(sponsor => sponsor.placement === placement)
    }

    if (status !== 'all') {
      const now = Date.now()

      filteredSponsors = status === 'active'
        ? filteredSponsors.filter(sponsor => sponsor.expired_at > now)
        : filteredSponsors.filter(sponsor => sponsor.expired_at < now)
    }

    this.setState({ displaySponsors: filteredSponsors })
  }

  removeSponsor = sponsor => {
    const updates = {}

    updates[`/sponsors/${sponsor.sponsorKey}`] = {}

    firebase
      .database()
      .ref()
      .update(updates)
      .then(err => {
        if (err) {
          alert(err)
        } else {
          this.removeImageFromStorage(sponsor.sponsorKey)
        }
      })
  }

  removeImageFromStorage = sponsorKey => {
    const desertRef = firebase
      .storage()
      .ref()
      .child(`sponsors/${sponsorKey}/image`)

    desertRef.delete().catch(err => {
      if (err.code !== 'storage/object-not-found') {
        alert(err)
      }
    })
  }

  renderHeader = () => {
    const { displaySponsors } = this.state

    return (
      <div>
        <Header size="large" style={{ display: 'inline-block' }}>
          Sponsors ({size(displaySponsors)})
        </Header>
        <Link to="/advertisement/sponsor/new" style={{ float: 'right' }}>
          <Button icon color="black">
            <Icon name="add" />
          </Button>
        </Link>
      </div>
    )
  }

  renderFilter = () => {
    const { placement, status } = this.state

    return (
      <div style={{ display: 'flex' }}>
        <DropdownField
          label="Placement"
          value={placement}
          options={PLACEMENT}
          onChange={val => this.setState({ placement: val })}
        />
        <DropdownField
          label="Status"
          value={status}
          options={STATUS}
          onChange={val => this.setState({ status: val })}
        />
        <Button
          icon
          onClick={this.onFilter}
        >
          <Icon name="filter" />
        </Button>
      </div>
    )
  }

  renderContent = () => {
    const { displaySponsors } = this.state

    if (size(displaySponsors) > 0) {
      const sponsorCards = map(displaySponsors, (sponsor, index) => {
        const { created_at: createdAt, expired_at: expiredAt, placement, restaurant, image, url } = sponsor
        const currentDate = Date.now()
        const status = currentDate > createdAt && currentDate < expiredAt
        const labelColor = status ? 'green' : 'red'
        return (
          <Card key={index} style={{ width: 320, minWidth: 320, maxWidth: 320 }}>
            <Image src={image} style={{ height: 180, width: 320 }}
            label={{ as: 'a', corner: 'left', color: labelColor }}
            />
            <Card.Content>
              <Card.Header>{restaurant}</Card.Header>
              <Card.Meta>
                <span className="date">
                  Start at {moment(Number(createdAt)).format('DD-MMM-YYYY HH:mm a')}
                </span>
              </Card.Meta>
              <Card.Meta>
                <span className="date">
                  Expire at {moment(Number(expiredAt)).format('DD-MMM-YYYY HH:mm a')}
                </span>
              </Card.Meta>
              {placement ? <Card.Meta>{`Placement: ${startCase(placement)}`}</Card.Meta> : null}
              {url && <Card.Meta>URL: {capitalize(url)}</Card.Meta>}
            </Card.Content>
            <Card.Content extra>
              <div className="ui two buttons">
                <Button onClick={() => this.onDeleteSponsorClick(sponsor)}>Delete</Button>
                <Button color="black" onClick={() => this.onEditSponsorClick(sponsor)}>
                  Edit
                </Button>
              </div>
            </Card.Content>
          </Card>
        )
      })

      return (
        <div style={{ marginTop: 14, overflowX: 'auto', overflowY: 'hidden' }}>
          <Card.Group
            id="sponsor-container"
            style={{
              display: 'inline-flex',
              flexWrap: 'nowrap',
              width: 'calc(100vw - 330px)',
            }}
          >
            {sponsorCards}
          </Card.Group>
        </div>
      )
    }

    return <div style={{ marginTop: 14 }}>No results</div>
  }

  render() {
    return (
      <Segment color="black">
        <div>
          {this.renderHeader()}
          {this.renderFilter()}
          {this.renderContent()}
        </div>
      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/advertisement/components/Sponsor.js